module.exports = __webpack_public_path__ + "static/img/far2.9bd4982d.png";